/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateScheduleRequest,
    CreateScheduleRequestFromJSON,
    CreateScheduleRequestToJSON,
} from '../models/CreateScheduleRequest';
import {
    type InspectionScheduleResponse,
    InspectionScheduleResponseFromJSON,
    InspectionScheduleResponseToJSON,
} from '../models/InspectionScheduleResponse';
import {
    type UpcomingOccurrenceResponse,
    UpcomingOccurrenceResponseFromJSON,
    UpcomingOccurrenceResponseToJSON,
} from '../models/UpcomingOccurrenceResponse';

export interface CreateScheduleOperationRequest {
    /**
     * 
     */
    createScheduleRequest: CreateScheduleRequest;
}

export interface DeleteScheduleRequest {
    /**
     * Schedule ID
     */
    id: string;
}

export interface GetAllSchedulesRequest {
    /**
     * Filter schedules by machine ID
     */
    machineId?: string;
}

export interface GetScheduleByIdRequest {
    /**
     * Schedule ID
     */
    id: string;
}

export interface GetUpcomingRequest {
    /**
     * Horizon in days (default 7, clamped 1..31)
     */
    days?: number;
}

export interface SetScheduleActiveRequest {
    /**
     * Schedule ID
     */
    id: string;
    /**
     * Whether to activate (true) or deactivate (false) the schedule
     */
    active: boolean;
}

export interface UpdateScheduleRequest {
    /**
     * Schedule ID
     */
    id: string;
    /**
     * 
     */
    createScheduleRequest: CreateScheduleRequest;
}

/**
 * 
 */
export class InspectionSchedulesApi extends runtime.BaseAPI {

    /**
     * Creates request options for createSchedule without sending the request
     */
    async createScheduleRequestOpts(requestParameters: CreateScheduleOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'createScheduleRequest',
                'Required parameter "createScheduleRequest" was null or undefined when calling createSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/schedules`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScheduleRequestToJSON(requestParameters['createScheduleRequest']),
        };
    }

    /**
     * Creates a new inspection schedule. Validates frequency-specific fields: CUSTOM requires cronExpression, PER_SHIFT requires shiftPattern.
     * Create a new schedule
     */
    async createScheduleRaw(requestParameters: CreateScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        const requestOptions = await this.createScheduleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new inspection schedule. Validates frequency-specific fields: CUSTOM requires cronExpression, PER_SHIFT requires shiftPattern.
     * Create a new schedule
     */
    async createSchedule(requestParameters: CreateScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.createScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteSchedule without sending the request
     */
    async deleteScheduleRequestOpts(requestParameters: DeleteScheduleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Permanently deletes an inspection schedule.
     * Delete a schedule
     */
    async deleteScheduleRaw(requestParameters: DeleteScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteScheduleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently deletes an inspection schedule.
     * Delete a schedule
     */
    async deleteSchedule(requestParameters: DeleteScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScheduleRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllSchedules without sending the request
     */
    async getAllSchedulesRequestOpts(requestParameters: GetAllSchedulesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['machineId'] != null) {
            queryParameters['machineId'] = requestParameters['machineId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves all inspection schedules. Optionally filter by machineId.
     * Get all schedules
     */
    async getAllSchedulesRaw(requestParameters: GetAllSchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        const requestOptions = await this.getAllSchedulesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all inspection schedules. Optionally filter by machineId.
     * Get all schedules
     */
    async getAllSchedules(requestParameters: GetAllSchedulesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.getAllSchedulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getScheduleById without sending the request
     */
    async getScheduleByIdRequestOpts(requestParameters: GetScheduleByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getScheduleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves a single inspection schedule by its identifier.
     * Get schedule by ID
     */
    async getScheduleByIdRaw(requestParameters: GetScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        const requestOptions = await this.getScheduleByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single inspection schedule by its identifier.
     * Get schedule by ID
     */
    async getScheduleById(requestParameters: GetScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.getScheduleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUpcoming without sending the request
     */
    async getUpcomingRequestOpts(requestParameters: GetUpcomingRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules/upcoming`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a read-only projection of schedule occurrences within the next N days (default 7). Each occurrence has a status of OVERDUE, DUE_NOW, or UPCOMING. These are NOT materialized forms — use POST /api/schedules/{id}/generate to create an actual task that can be assigned or completed.
     * Forecast upcoming schedule occurrences
     */
    async getUpcomingRaw(requestParameters: GetUpcomingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpcomingOccurrenceResponse>> {
        const requestOptions = await this.getUpcomingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpcomingOccurrenceResponseFromJSON(jsonValue));
    }

    /**
     * Returns a read-only projection of schedule occurrences within the next N days (default 7). Each occurrence has a status of OVERDUE, DUE_NOW, or UPCOMING. These are NOT materialized forms — use POST /api/schedules/{id}/generate to create an actual task that can be assigned or completed.
     * Forecast upcoming schedule occurrences
     */
    async getUpcoming(requestParameters: GetUpcomingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpcomingOccurrenceResponse> {
        const response = await this.getUpcomingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setScheduleActive without sending the request
     */
    async setScheduleActiveRequestOpts(requestParameters: SetScheduleActiveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setScheduleActive().'
            );
        }

        if (requestParameters['active'] == null) {
            throw new runtime.RequiredError(
                'active',
                'Required parameter "active" was null or undefined when calling setScheduleActive().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules/{id}/activate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Toggles the active state of a schedule without deletion. When deactivated, future form generation stops but the schedule and its history are preserved. When activated, nextGenerationAt is recalculated.
     * Activate or deactivate a schedule
     */
    async setScheduleActiveRaw(requestParameters: SetScheduleActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        const requestOptions = await this.setScheduleActiveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Toggles the active state of a schedule without deletion. When deactivated, future form generation stops but the schedule and its history are preserved. When activated, nextGenerationAt is recalculated.
     * Activate or deactivate a schedule
     */
    async setScheduleActive(requestParameters: SetScheduleActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.setScheduleActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSchedule without sending the request
     */
    async updateScheduleRequestOpts(requestParameters: UpdateScheduleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSchedule().'
            );
        }

        if (requestParameters['createScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'createScheduleRequest',
                'Required parameter "createScheduleRequest" was null or undefined when calling updateSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/schedules/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScheduleRequestToJSON(requestParameters['createScheduleRequest']),
        };
    }

    /**
     * Updates an inspection schedule. Recalculates nextGenerationAt based on the new frequency configuration.
     * Update an existing schedule
     */
    async updateScheduleRaw(requestParameters: UpdateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        const requestOptions = await this.updateScheduleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Updates an inspection schedule. Recalculates nextGenerationAt based on the new frequency configuration.
     * Update an existing schedule
     */
    async updateSchedule(requestParameters: UpdateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.updateScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
